import { Button } from '../../../Button';
import { ColumnDef } from '@tanstack/react-table';
import { ChevronDown } from 'lucide-react';
import { cn } from '../../../../lib/utils';
import useI18n from '../../../../hooks/useI18n';

export const EXPANDABLE_COLUMN_ID = 'expandable';
const CHEVRON_CLASSES =
  'eye:size-s eye:stroke-[1.5] eye:transition-transform eye:duration-200';

export function ExpandableColumn<TData>(): ColumnDef<TData> {
  const { t } = useI18n();

  return {
    accessorKey: EXPANDABLE_COLUMN_ID,
    enableColumnFilter: false,
    enableSorting: false,
    enableHiding: false,
    size: 65,
    header: ({ table }) => {
      const isExpanded = table.getIsAllRowsExpanded();

      return (
        <Button
          className='eye:size-s! eye:align-middle eye:outline-offset-[-2px]'
          size='icon'
          variant='ghost'
          aria-label={isExpanded ? t('collapseRows') : t('expandRows')}
          onClick={() => table.toggleAllRowsExpanded(!isExpanded)}
        >
          <ChevronDown
            className={cn(CHEVRON_CLASSES, isExpanded ? 'eye:rotate-180' : '')}
            aria-hidden='true'
          />
        </Button>
      );
    },
    cell: ({ row }) => {
      const isExpanded = row.getIsExpanded();

      return (
        <Button
          className='eye:size-s! eye:align-middle'
          size='icon'
          variant='ghost'
          aria-label={isExpanded ? t('collapseRow') : t('expandRow')}
          onClick={() => row.toggleExpanded(!isExpanded)}
        >
          <ChevronDown
            className={cn(CHEVRON_CLASSES, isExpanded ? 'eye:rotate-180' : '')}
            aria-hidden='true'
          />
        </Button>
      );
    },
  };
}
